export default {"src":"/_next/static/media/emptymap.31e3f432.svg","height":48,"width":48};